import { bodyRegular } from '@monorepo/shared/styles/text';
import styled from 'styled-components';

export const StyledPreviewMessage = styled.div`
  ${bodyRegular}
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1rem;
  color: ${({ theme }) => theme.colors.gray666};
  text-align: center;
`;
